/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notanadmin2Inputs */

const en_notanadmin2 = /** @type {(inputs: Notanadmin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not an admin?`)
};

const de_notanadmin2 = /** @type {(inputs: Notanadmin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Admin?`)
};

/**
* | output |
* | --- |
* | "Not an admin?" |
*
* @param {Notanadmin2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const notanadmin2 = /** @type {((inputs?: Notanadmin2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notanadmin2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notanadmin2(inputs)
	return de_notanadmin2(inputs)
});
export { notanadmin2 as "notAnAdmin" }